// @ts-expect-error - Grid is not typed correctly I guess, it's used elsewhere in this way and works properly
import { Grid } from 'react-loader-spinner'
import { useTranslation } from 'react-i18next'
import { Flex } from '@/components/priority/Flex/Flex'
import { Text } from '@/components/priority/Text/Text'
import { zLayers } from '@/utils/styling/zLayers'
import { BULK_PROCESSING_TURNOVER_ACTION } from '@/atoms/_editorAtoms'

type BulkProcessingProgress = {
  processedCount: number
  totalCount: number
  currentAction: string
}

type BulkProcessingOverlayProps = {
  progress: BulkProcessingProgress
}

/**
 * Overlay that appears during bulk image processing operations, and while a
 * page set turns over to new text boxes (`BULK_PROCESSING_TURNOVER_ACTION`),
 * which it says instead of an image count.
 * Shows progress indicator and current processing status.
 *
 * Note: Detailed error reporting happens in QuickActionsDrawer via toast messages.
 * This overlay focuses on showing progress during the operation.
 */
export const BulkProcessingOverlay = ({
  progress,
}: BulkProcessingOverlayProps) => {
  const { t } = useTranslation()
  const turningOver = progress.currentAction === BULK_PROCESSING_TURNOVER_ACTION

  return (
    <Flex
      blur
      full
      center
      column
      height="100%"
      top="0"
      right="0"
      bottom="0"
      left="0"
      position="absolute"
      zindex={String(zLayers.modal)}
      background="rgba(255, 255, 255, 0.85)"
      data-editor-ui="bulk-processing-overlay"
    >
      <Grid color="#333" height={60} width={60} />
      <Text
        margin="24px 0 8px"
        size="14px"
        weight="500"
        color="lockedBlack"
        align="center"
      >
        {turningOver
          ? t('editor.textBox.turnover.overlay')
          : t(
              'editor.menus.properties.elements.bulkQuickActions.processingMessage',
              {
                current: progress.processedCount,
                total: progress.totalCount,
              },
            )}
      </Text>
      <Text
        margin="8px 0 0"
        size="12px"
        weight="400"
        color="lockedBlack"
        align="center"
      >
        {turningOver
          ? t('editor.textBox.turnover.overlayWait')
          : t(
              'editor.menus.properties.elements.bulkQuickActions.pleaseWaitMessage',
            )}
      </Text>
    </Flex>
  )
}
